import { createRouter, createWebHistory } from 'vue-router'
import equityChart from '@/views/equityChart.vue'

const routes = [
  { path: '/', name: 'equity-chart', component: equityChart }
]

const router = createRouter({
  history: createWebHistory(), // HTML5 模式，无 #
  routes
})

export default router